import { useMemo } from 'react';
import { ActionType, IntegrationTermsAndConditions } from '../../../lib/api/account-linking/types';
import StepInput from './StepInput';
import { P2GLink } from '@parcel2go/core-ui';
import { P2GText } from '@parcel2go/core-ui';
import { Trans, useTranslation } from 'react-i18next';
import { TranslationNamespaces } from '~/lib/constants';

interface props {
  terms: IntegrationTermsAndConditions;
  value: string;
  disabled: boolean;
  onUpdate: (key: string, value: string) => void;
  integrationType: string;
  integrationSlug: string;
  action: ActionType;
}

const TermsLabel: React.FC<props> = (props) => {
  const { t } = useTranslation(TranslationNamespaces.ACCOUNT_LINKING);
  const label = useMemo(() => {
    // Not sure theres a better way to do this at the moment.
    if (props.terms.input.placeholder === "By clicking 'Link Account', you agree to our Terms and Conditions.") {
      return (
        <P2GText variant="body2">
          <Trans
            i18nKey="TERMS_LABEL"
            t={t}
            defaults="By clicking 'Link Account', you agree to our <a>Terms and Conditions</a>."
            components={{ a: <P2GLink href={props.terms.url} target="_blank" /> }}
          />
        </P2GText>
      );
    }

    return (
      <P2GText variant="body2">
        {props.terms.input.placeholder}{' '}
        <P2GLink href={props.terms.url} target="_blank">
          {t('TERMS_LINK', { defaultValue: 'View Here' })}
        </P2GLink>
      </P2GText>
    );
  }, [props.terms]);

  return (
    <StepInput
      disabled={props.disabled}
      input={props.terms.input}
      value={props.value}
      onUpdate={props.onUpdate}
      label={label}
      action={props.action}
      integrationType={props.integrationType}
      integrationSlug={props.integrationSlug}
    />
  );
};
export default TermsLabel;
